const DETAILS_TAB_SECTIONS = {
    DETAILS: 'details',
    CONNECTION_POINTS: 'connection_points',
    LEGAL_INFOS: 'legal_infos',
    CUSTOMIZATION: 'customization',
    ALERTS: 'alerts',
    SIM_OFFERS: 'sim_offers'
};

export default DETAILS_TAB_SECTIONS;